import Swal from "sweetalert2";
import * as Sentry from "@sentry/react";


export const handleException = (error, title, description) => {
    // 1- Ignore 401 errors
    if (error.response?.status === 401) return;

    // 2- Add Sentry error handling
    Sentry.withScope(scope => {
        if (title) scope.setTag("error.title", title);
        if (description) scope.setExtra("error.description", description);
        Sentry.captureException(error);
    });

    // 3- Show error message
    const errorMessage =
        error?.response?.data?.errorMessage ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        error;

    Swal.fire({
        icon: "error",
        title: title || "Unexpected Error",
        html: `<div style="font-size:16px; line-height:1.5;">${description ? `<p>${description}</p>` : ""}<p>${errorMessage}</p></div>`,
        confirmButtonText: "Close",
        customClass: { confirmButton: "btn btn-secondary" },
        width: "30em",
    });
}